let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aygwN")).then(() => parcelRequire('9DioN'));